import { Injectable } from '@angular/core';
import { BranchTypesService } from '../../branch-types/logic/branch-types.service';
import { BranchesService } from '../../branches/logic/branches.service';
import { ClientStateService } from '../../client-state/logic/client-state.service';
import { LoggingService } from '../../logging/logic/logging.service';
import { TourStopsService } from '../../tour-stop/logic/tour-stop.service';
import {
  VisibilityRuleService,
  VisibilityRule,
} from '../visibility-rule-service';
import { TourService } from '../../tour/logic/tour.service';

@Injectable({
  providedIn: 'root',
})
export class IsNormalTourVisibilityService implements VisibilityRuleService {
  // Public Member
  public readonly name: VisibilityRule = 'isNormalTour';

  // Lifecycle
  constructor(
    private logger: LoggingService,
    private clientStateService: ClientStateService,
    private tourService: TourService
  ) {}

  // VisibilityRuleService
  public isVisible(params: any): boolean {
    const tourId = this.clientStateService.theState.getValue().tourId;

    if (tourId == undefined) {
      return false;
    }

    const tour = this.tourService.getTourById(tourId);

    if (tour == undefined) {
      return false;
    }

    return tour.isNormalTour;
  }

  // Private Functions
}
